// src/config/permissoesDefault.js
// Matriz de permissões "de fábrica".
// Pode ser sobrescrita via /grupos/{grupoId}/config/permissoes (campo overrides).

import { NIVEIS } from "./niveis";

export const PERMISSOES_DEFAULT = {
  // ===================== Cadastros =====================
  cadastros: {
    usuarios: {
      // Admin (5) pode criar/editar somente usuários abaixo de 5 (0–4). A validação fica no formulário.
      tabela: { nivelMinimo: NIVEIS.TECNICO },
      form: { nivelMinimo: NIVEIS.ADMIN },
      altera: { nivelMinimo: NIVEIS.ADMIN },
    },

    empresas: {
      tabela: { nivelMinimo: NIVEIS.GESTOR },
      form: { nivelMinimo: NIVEIS.GESTOR },
      altera: { nivelMinimo: NIVEIS.GESTOR },
      deleta: { nivelMinimo: NIVEIS.GESTOR },
    },

    setores: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
      form: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      altera: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      deleta: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },

    maquinas: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
      form: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      altera: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },


    fornecedores: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
      form: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      altera: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },

    // Prestador de Serviço - Tabela, Form e Alterar (4)
    prestadores: {
      tabela: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      form: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      altera: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },
    // Cooperadores (Manutenção)
    cooperadores: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
      form: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      altera: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },


    pecas: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
      form: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      altera: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },

    procedimentos: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
      form: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      altera: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },

    status: {
      tabela: { nivelMinimo: NIVEIS.GESTOR },
      form: { nivelMinimo: NIVEIS.GESTOR },
      altera: { nivelMinimo: NIVEIS.GESTOR },
    },

    defeitos: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
      form: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      altera: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },

    // Cadastro de Preventivas (configuração)
    preventivas: {
      tabela: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      form: { nivelMinimo: NIVEIS.GESTOR },
      altera: { nivelMinimo: NIVEIS.GESTOR },
      duplicar: { nivelMinimo: NIVEIS.GESTOR },
    },

    // Cadastro de Checklists (configuração)
    checklists: {
      tabela: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
      form: { nivelMinimo: NIVEIS.GESTOR },
      altera: { nivelMinimo: NIVEIS.GESTOR },
    },
  },

  // ===================== Ordens de Serviço =====================
  ordensServico: {
    abrirNovaOS: {
      form: { nivelMinimo: NIVEIS.KIOSK },
    },

    // Edição da OS (tela de edição /ordens-servico/editar/:osId)
    editarOS: {
      form: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },

    // Ordens de Serviço - Por Status (3)
    porStatus: {
      // Cliente deve conseguir acompanhar apenas as próprias OS.
      // O filtro de escopo ("proprias") é aplicado nas telas de OS.
      tabela: { nivelMinimo: NIVEIS.CLIENTE },
    },

    // Ordens de Serviço - Periodicidade (3)
    periodicidade: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
    },

    meusAtendimentos: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
    },
  },

  // ===================== Preventivas (execução) =====================
  preventivas: {
    // Listagens e calendário (módulo operacional)
    abertas: { tabela: { nivelMinimo: NIVEIS.TECNICO } },
    finalizadas: { tabela: { nivelMinimo: NIVEIS.TECNICO } },
    calendario: { tabela: { nivelMinimo: NIVEIS.TECNICO } },

    // Execução
    execucao: {
      iniciarExecucao: { nivelMinimo: NIVEIS.TECNICO },
    },
  },

  // ===================== Checklists (execução) =====================
  checklists: {
    // Listagens e calendário (módulo operacional)
    abertas: { tabela: { nivelMinimo: NIVEIS.TECNICO } },
    finalizadas: { tabela: { nivelMinimo: NIVEIS.TECNICO } },
    calendario: { tabela: { nivelMinimo: NIVEIS.TECNICO } },

    // Execução (futuro / quando houver fluxo operacional completo)
    execucao: {
      iniciarExecucao: { nivelMinimo: NIVEIS.TECNICO },
    },
  },

  // ===================== Planejamento =====================
  planejamento: {
    agendamentos: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
    },
    calendario: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
    },
    atendimentosVisitas: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
    },
  },

  // ===================== KPIs (Manutenção) =====================
  kpis: {
    mtbf: { tabela: { nivelMinimo: NIVEIS.ADMIN } },
    mttr: { tabela: { nivelMinimo: NIVEIS.ADMIN } },
    tecnicos: { tabela: { nivelMinimo: NIVEIS.ADMIN } },
    custoManutencao: { tabela: { nivelMinimo: NIVEIS.ADMIN } },
    outros: { tabela: { nivelMinimo: NIVEIS.ADMIN } },
  },

  // ===================== Estoque =====================
  estoque: {
    estoqueInterno: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
      altera: { nivelMinimo: NIVEIS.ADMIN },
      deleta: { nivelMinimo: NIVEIS.ADMIN },
    },

    pedidosMaterial: {
      tabela: { nivelMinimo: NIVEIS.TECNICO },
      form: { nivelMinimo: NIVEIS.TECNICO },
      altera: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },
  },

  // ===================== Opções =====================
  gerenciar: {
    opcoes: {
      acessa: { nivelMinimo: NIVEIS.KIOSK },
      aparencia: { nivelMinimo: NIVEIS.KIOSK },
      ia: { nivelMinimo: NIVEIS.GESTOR },
      relatorios: { nivelMinimo: NIVEIS.GESTOR },
      whatsapp: { nivelMinimo: NIVEIS.GESTOR },
      permissoes: { nivelMinimo: NIVEIS.GESTOR },
    },

    // ===================== Gerenciar (Manutenção) =====================
    // Esses itens estavam controlados por nível fixo no menu; agora entram na matriz
    // para permitir ajustes por grupo/usuário.
    dashboard: {
      acessa: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },
    tabelaOS: {
      tabela: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },
    tabelaAtendimentos: {
      tabela: { nivelMinimo: NIVEIS.TECNICO_SENIOR },
    },
    importarExportar: {
      acessa: { nivelMinimo: NIVEIS.ADMIN },
    },

    // Troca de empresa/cliente (escopo do usuário ou global do grupo)
    // Deve ser acessível para qualquer usuário logado (exceto Dashboard=0),
    // pois define o contexto de dados do app.
    mudarEmpresa: {
      acessa: { nivelMinimo: NIVEIS.KIOSK },
    },
  },
};
